// Model.js
// -----------------------
// @module Case
define("Code25.CaterpartsGlobal.CSV.Model", ["Backbone", "Utils","underscore"], function(
    Backbone,
    Utils,
    _
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: _.getAbsoluteUrl(getExtensionAssetsPath('services/CSV.Service.ss'))
});
});


